<template>
  <div class="container">
    <!--<h3 class="green subtitle" v-if="orderbool">
      {{ $translate("subtitle_form_model_fodera_order") }}
    </h3>-->
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_fodera') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column is-8">
        <div class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('fodantmat') }"
              :label="$translate('fodantmat') | capitalize"
              :message="errors.first('fodantmat')"
            >
              <b-select
                v-model="mod.fodantmat"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                name="fodantmat"
                :placeholder="$translate('placeholder_select')"
                @input="changepell1"
              >
                <option
                  v-for="optio in availablefode"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.fodantmat != null"
              :message="errors.first('fodantvar')"
              :type="{ 'is-danger': errors.has('fodantvar') }"
              :label="$translate('fodantvar') | capitalize"
            >
              <b-select
                v-model="mod.fodantvar"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                name="fodantvar"
                :placeholder="$translate('placeholder_select')"
                @input="changeImage1"
              >
                <template v-for="optio in availablefode">
                  <template v-if="optio.id == mod.fodantmat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="image1 == null ? 'https://place-hold.it/150x150' : image1"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('fodposmat') }"
              :label="$translate('fodposmat') | capitalize"
              :message="errors.first('fodposmat')"
            >
              <b-select
                v-model="mod.fodposmat"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                name="fodposmat"
                :placeholder="$translate('placeholder_select')"
                @input="changepell2"
              >
                <option
                  v-for="optio in availablefode"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.fodposmat != null"
              :message="errors.first('fodposvar')"
              :type="{ 'is-danger': errors.has('fodposvar') }"
              :label="$translate('fodposvar') | capitalize"
            >
              <b-select
                v-model="mod.fodposvar"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                name="fodposvar"
                :placeholder="$translate('placeholder_select')"
                @input="changeImage2"
              >
                <template v-for="optio in availablefode">
                  <template v-if="optio.id == mod.fodposmat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="image2 == null ? 'https://place-hold.it/150x150' : image2"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <b-field :label="$translate('addingcharfod') | capitalize">
          <b-select
            v-model="mod.addingcharfod"
            multiple
            native-size="5"
            :disabled="orderbool"
            name="addingcharfod"
            :placeholder="$translate('placeholder_select')"
          >
            <option v-for="option in optionsaddingcharfod" :key="option" :value="option">
              {{ option }}
            </option>
          </b-select>
        </b-field>
        <p class="content">* {{ $translate('multiple_select_info') | capitalize }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fodera',
  props: ['orderbool', 'mod', 'availablefode', 'disabledbool', 'orderInfoMandatory'],
  data() {
    return {
      image1: null,
      image2: null,
      optionsaddingcharfod: [],
    }
  },
  inject: ['$validator'],
  watch: {
    mod: function() {
      this.updateAfterload()
    },
  },
  methods: {
    resetTag() {
      let fondmat = this.availablefode.find(temp => temp.id == this.mod.fodantmat)
      let fondposmat = this.availablefode.find(temp => temp.id == this.mod.fodposmat)

      this.optionsaddingcharfod = []
      if (fondmat) {
        for (let indextag in fondmat.optional_tag) {
          if (!this.optionsaddingcharfod.includes(fondmat.optional_tag[indextag].key)) {
            this.optionsaddingcharfod.push(fondmat.optional_tag[indextag].key)
          }
        }
      }
      if (fondposmat) {
        for (let indextag in fondposmat.optional_tag) {
          if (!this.optionsaddingcharfod.includes(fondposmat.optional_tag[indextag].key)) {
            this.optionsaddingcharfod.push(fondposmat.optional_tag[indextag].key)
          }
        }
      }
    },
    changepell1() {
      this.resetTag()
      this.mod.fodantvar = null
      this.image1 = null
    },
    changepell2() {
      this.resetTag()
      this.mod.fodposvar = null
      this.image2 = null
    },
    changeImage1() {
      this.image1 = null
      this.resetTag()
      for (let index in this.availablefode) {
        if (this.availablefode[index].id == this.mod.fodantmat) {
          for (let index2 in this.availablefode[index].variants) {
            if (this.availablefode[index].variants[index2].id == this.mod.fodantvar) {
              this.image1 = this.availablefode[index].variants[index2].image
            }
          }
        }
      }
    },
    changeImage2() {
      this.image2 = null
      this.resetTag()
      for (let index in this.availablefode) {
        if (this.availablefode[index].id == this.mod.fodposmat) {
          for (let index2 in this.availablefode[index].variants) {
            if (this.availablefode[index].variants[index2].id == this.mod.fodposvar) {
              this.image2 = this.availablefode[index].variants[index2].image
            }
          }
        }
      }
    },

    updateAfterload() {
      if (!this.mod.addingcharfod) this.$set(this.mod, 'addingcharfod', [])
      this.changeImage1()
      this.changeImage2()
    },
  },
}
</script>
